import { Component } from '@angular/core';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-logo-strip',
  standalone: true,
  imports: [NgFor],
  template: `
  <section class="strip">
    <div class="label">Nos clients :</div>
    <div class="items">
      <span class="item" *ngFor="let i of industries">{{i}}</span>
    </div>
  </section>
  `,
  styles: [`
    .strip{
      border-radius: 22px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.03);
      padding: 14px 14px;
      display:flex;
      gap: 12px;
      align-items:center;
      flex-wrap:wrap;
      box-shadow: 0 30px 120px rgba(0,0,0,.45);
    }
    .label{ color: rgba(235,240,255,.74); font-weight: 900; }
    .items{ display:flex; gap: 10px; flex-wrap:wrap; }
    .item{
      padding: 8px 12px;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      color: rgba(235,240,255,.78);
      font-weight: 850;
      font-size: 13px;
    }
  `]
})
export class LogoStripComponent {
  industries = ['SaaS', 'Retail', 'Finance', 'Industrie', 'E‑commerce'];
}
